'use client';
import React, { useRef } from "react";
import FooterSection from "@/sections/FooterSection";
import CTASection from "@/sections/CTASection";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { LanguageType, CTASectionContent, BrandInfoSectionContent } from '@/lib/types';

import { debug } from '@/lib/debug';
gsap.registerPlugin(useGSAP, ScrollTrigger);

interface FooterWrapperProps {
  language: LanguageType;
  setLanguage: (newLanguage: string) => void;
  ctaSectionPageData: CTASectionContent;
  brandInfoSectionPageData: BrandInfoSectionContent;
}

const FooterWrapper: React.FC<FooterWrapperProps> = ({ language, setLanguage, ctaSectionPageData, brandInfoSectionPageData }) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const ctaSectionRef = useRef<HTMLElement>(null);

  return (
    <div className="w-full flex flex-col gap-[5rem]">
      <CTASection
        id="cta-section"
        heading={ctaSectionPageData?.title || "mock title"}
        paragraph={ctaSectionPageData?.description || "mock description"}
        buttonText={language === 'arabic' ? "كن أحد أعضائنا" : "Become a member"}
        // imageSrc="./hero-image.avif"
        imageSrc="https://dependable-apparel-f6b4f02674.media.strapiapp.com/Index_CTA_4cd0e2c782.webp"
        imageAlt="Mountain landscape"
        language={language}
        ctaSectionRef={ctaSectionRef}
        // footerHeight={footerHeight}
      />

      <FooterSection
        footerRef={footerRef}
        ctaSectionRef={ctaSectionRef}
        language={language}
        setLanguage={setLanguage}
        brandInfoSectionPageData={brandInfoSectionPageData}
      />
    </div>
  );
};

export default FooterWrapper; 